/**
 * Cart Entry Point
 *
 * Mounts the CartPage component on the cart page.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ShopProvider } from '@/context';
import { CartPage } from '@/components/Cart/CartPage';

const container = document.getElementById('evcs-cart');

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ShopProvider>
        <CartPage />
      </ShopProvider>
    </StrictMode>
  );
}
